import { atom } from "jotai";

import { SimpleResult } from "../simple-result/simple-result";

import { IReceiptWithSource } from "../models";

/** The receipt currently open in the receipt modal. */
export const receiptAtom = atom<IReceiptWithSource | null>(null);

/** Own loading/error pair — see `receiptsLoadingAtom` for why: the receipt
 * modal can be opened while the register page's own fetches are in flight. */
export const receiptLoadingAtom = atom<boolean>(false);
export const receiptErrorAtom = atom<SimpleResult<unknown> | null>(null);
